import { Button } from '@elements/button'
import { QueueListIcon } from '@heroicons/react/24/outline'
import { useOpenState } from '@hooks/open-state'
import { GuestlistModal } from '@modules/booking/views/guestlist-modal'
import {
  inventoryWidgetAttributions,
  widgetAttribution,
} from '@modules/widget/constants'
import { Venue } from 'types/model'

interface GuestlistRequestButtonProps {
  venue: Venue
  title?: string
  date?: string
  attributionId?: string | null
  affiliateId?: string | null
  onGuestlistModalOpen?: () => void
}

export function GuestlistRequestButton({
  venue,
  title = 'Join the Guestlist',
  date = new Date().toISOString(),
  attributionId,
  affiliateId,
  onGuestlistModalOpen,
}: GuestlistRequestButtonProps) {
  const guestlistModal = useOpenState()

  const guestlistFormAttribution =
    attributionId && inventoryWidgetAttributions.has(attributionId)
      ? widgetAttribution.widget
      : attributionId

  return (
    <>
      <Button.Primary
        sm
        className='w-full !text-base'
        rightIcon={QueueListIcon}
        onClick={onGuestlistModalOpen || guestlistModal.open}
      >
        {title}
      </Button.Primary>
      <GuestlistModal
        {...guestlistModal}
        venue={venue}
        date={date}
        attributionId={guestlistFormAttribution}
        affiliateId={affiliateId}
      />
    </>
  )
}
